'use client';

import { useEffect } from 'react';

import { trpc } from '@/lib/trpc/client';

import { useSetState } from '../hooks/use-set-state';

interface UseOnlineMembersResult {
  onlineMemberIds: Set<string>;
  markOnline: (memberId: string) => void;
  markOffline: (memberId: string) => void;
}

export function useOnlineMembers(
  enabled: boolean = true,
): UseOnlineMembersResult {
  const {
    items: onlineMemberIds,
    add: markOnline,
    remove: markOffline,
    setItems: setOnlineMemberIds,
  } = useSetState<string>();

  const { data } = trpc.realtime.getOnlineMemberIds.useQuery(undefined, {
    enabled,
    staleTime: 30_000,
  });

  useEffect(() => {
    if (data) {
      setOnlineMemberIds(new Set(data));
    }
  }, [data, setOnlineMemberIds]);

  return { onlineMemberIds, markOnline, markOffline };
}
